export function getCategoryLabel (store, categoryId) {
  const raw = store.getters['donnees/getCategoryPortals']
  const categories = (raw && raw.categories) ? raw.categories : raw
  return categories[categoryId]
}
